import Loader from "@components/Loader";
import { IProfile } from "@interfaces/Core/Account/profile";
import { ReactElement } from "react";
import { Card, CardBody, Col } from "reactstrap";

interface IProfileMain {
  profile: IProfile | null;
  isLoading: boolean;
}

const ProfileMain = ({ profile, isLoading }: IProfileMain): ReactElement => (
  <Col md={12} lg={12} xl={12}>
    <Card>
      <CardBody className="profile__card">
        {isLoading ? (
          <Loader isInsideThing />
        ) : (
          <>
            <div className="profile__information">
              <div className="profile__data">
                <p className="profile__name">
                  {profile?.name} {profile?.lastname}
                </p>
                <p className="profile__work">@{profile?.username}</p>
                <p className="profile__contact">
                  <a href={`mailto:${profile?.mail}`}>{profile?.mail}</a>
                </p>
              </div>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  </Col>
);

export default ProfileMain;
